import { ConfigFields } from 'features/change-config/ui/config-fields';
import { useQuery } from '@tanstack/react-query';
import { getMarketplaceConfigs } from '@/enteties/marketplace/api';
import { useEffect, useMemo } from 'react';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { useFormContext } from 'react-hook-form';
import { setDefaultValues } from 'features/change-config/util';
export const MarketplaceConfig = () => {
  const {
    selectedMarketplace,
    selectedProjectType
  } = useServiceType();
  const form = useFormContext();
  const {
    data: marketplaceConfig
  } = useQuery({
    ...getMarketplaceConfigs.getMarketplaceConfigsQueryOptions()
  });
  const marketplaceData = useMemo(() => {
    if (!selectedProjectType || !selectedMarketplace) return {};
    return marketplaceConfig?.[selectedProjectType]?.[selectedMarketplace]['1'];
  }, [marketplaceConfig, selectedMarketplace, selectedProjectType]);
  useEffect(() => {
    const tariffValues = form.getValues();
    const formDefaults = setDefaultValues(marketplaceData, selectedProjectType!, selectedMarketplace!);
    form.reset({
      version: '1',
      name: tariffValues.name,
      tariffId: tariffValues.tariffId,
      ...formDefaults
    }, {
      keepIsSubmitted: true
    });
  }, []);
  return <ConfigFields toolchainDataInit={marketplaceData} environment={selectedProjectType!} toolchainName={selectedMarketplace!} data-sentry-element="ConfigFields" data-sentry-component="MarketplaceConfig" data-sentry-source-file="marketplace-config.tsx" />;
};